import { T_CONTACT_US_FORM_PAGE_CONSTANTS } from './TYPES'

const HU_CONTACT_US_FORM_PAGE_CONSTANTS: T_CONTACT_US_FORM_PAGE_CONSTANTS = {
  FULL_NAME_LABEL: 'Teljes név',
  FULL_NAME_PLACEHOLDER: 'Adja meg a teljes nevét',
  FULL_NAME_ERRORS_REQUIRED: 'A teljes név megadása kötelező.',
  EMAIL_ID_LABEL: 'Email cím',
  EMAIL_ID_PLACEHOLDER: 'Adja meg az email címét',
  EMAIL_ID_ERRORS_REQUIRED: 'Az email cím megadása kötelező.',
  EMAIL_ID_ERRORS_INVALID: 'Adjon meg egy érvényes email címet.',
  SUBJECT_LABEL: 'Tárgy',
  SUBJECT_PLACEHOLDER: 'Adja meg a tárgyat',
  SUBJECT_ERRORS_REQUIRED: 'A tárgy megadása kötelező.',
  MESSAGE_LABEL: 'Az Ön üzenete',
  MESSAGE_PLACEHOLDER: 'Adja meg az üzenetét',
  MESSAGE_ERRORS_REQUIRED: 'Az üzenet megadása kötelező.',
  SEND_CTA_TEXT: 'Küldés'
}

export default HU_CONTACT_US_FORM_PAGE_CONSTANTS
